module.exports = __webpack_public_path__ + "media/images/pc/top/kodawari_photowedding@3x-815da1768be2cdd09b57f59845ba5ecd.webp";